import { SystemBanners } from "@portal/components/features/banner/SystemBanners";
import { MainLayout } from "@portal/components/layout/MainLayout";
import { ReactNode } from "react";
import { AgentMainNav } from "./AgentMainNav";

export const AgentMainLayout = (props: { children: ReactNode }) => (
	<MainLayout
		mainNav={<AgentMainNav />}
		topBanner={<SystemBanners className="flex flex-col gap-2 w-full px-6 py-4" />}
	>
		{props.children}
	</MainLayout>
);
